import axios from "axios";
import {
	ACCESS_TOKEN,
	CREATE_STOCK_ADJUSTMENTS_URL,
	DELETE_STOCK_URL,
	GET_STOCK_BY_ID,
	GET_STOCK_LIST,
	POST_STOCK_URL,
	UPDATE_STOCK_URL,
	VERIFY_STOCK_URL,
} from "../helpers/Constant";

export default class StockService {
	static getStockList(params) {
		return axios.get(GET_STOCK_LIST, {
			...StockService.getAuthHeader(),
			params,
		});
	}

	static getStockById(id) {
		return axios.get(
			`${GET_STOCK_BY_ID}/${id}`,
			StockService.getAuthHeader(),
		);
	}

	static addStock(data) {
		return axios.post(POST_STOCK_URL, data, StockService.getAuthHeader());
	}

	static editStock(id, data) {
		return axios.put(
			`${UPDATE_STOCK_URL}/${id}`,
			data,
			StockService.getAuthHeader(),
		);
	}

	static verifyStock(id) {
		return axios.put(
			`${VERIFY_STOCK_URL}/${id}`,
			{},
			StockService.getAuthHeader(),
		);
	}

	static deleteStock(id) {
		return axios.delete(
			`${DELETE_STOCK_URL}/${id}`,
			StockService.getAuthHeader(),
		);
	}

	static createStockAdjustments(data) {
		return axios.post(
			CREATE_STOCK_ADJUSTMENTS_URL,
			data,
			StockService.getAuthHeader(),
		);
	}

	static getAuthHeader = () => {
		const accessToken = localStorage.getItem(ACCESS_TOKEN);
		return { headers: { "x-auth-token": accessToken } };
	};
}
